import Tools from "../Tools";
import ad_industry from "../vo/dbvo/ad_industry";

export type InputAdd = {
    name: string;
};

export type InputUpdateTagName = {
    name: string;
    unique_identifier: string
};

/**
 * 行业相关API
 */
export default class IndustryApi {

    /**
     * 添加行业类型
     */
    public async AddAsync(input: InputAdd) {
        return Tools.FetchAsync("Industry/Add", input, "POST");
    }

    /**
     * 获取行业列表
     */
    public async GetListAsync(page: number, pageSize: number) {
        return Tools.FetchAsync<{
            allcount: number,
            pagecount: number,
            data: ad_industry[]
        }>("Industry/GetList", {
            page,
            pageSize
        }, "GET");
    }

    /**
     * 删除行业标签
     * @param unique_identifier 
     */
    public async DeleteAsync(unique_identifier: string) {
        return Tools.FetchAsync("Industry/Delete", {
            unique_identifier
        }, "DELETE");
    }

    /**
     * 修改行业标签名称
     */
    public async UpdateTagNameAsync(input: InputUpdateTagName) {
        return Tools.FetchAsync("Industry/UpdateTagName", input, "PATCH");
    }
}